import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppPath, Authorities } from '@ipensii/shared/domain-shared';
import { RouterLink } from '@angular/router';
import { DashboardCardComponent } from '../../card/dashboard-card/dashboard-card.component';

@Component({
  selector: 'ip-shared-reporting-dashboard',
  standalone: true,
  imports: [CommonModule, DashboardCardComponent, RouterLink],
  templateUrl: './reporting-dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportingDashboardComponent {
  @Input({ required: true }) userAuthorities!: Array<Authorities>;

  protected readonly Authorities = Authorities;
  protected readonly AppPath = AppPath;
}
